// src/components/NavItem.jsx
import React from "react";

const NavItem = ({ page, label, setCurrentPage, currentPage }) => {
  return (
    <button
      onClick={() => setCurrentPage(page)}
      className={`relative text-white font-semibold hover:text-amber-300 transition-colors duration-300 py-2 px-4 rounded-xl
                  ${
                    currentPage === page
                      ? "text-amber-200 after:absolute after:bottom-0 after:left-1/2 after:w-3/4 after:h-1 after:bg-amber-400 after:rounded-full after:-translate-x-1/2 animate-pulse-once"
                      : ""
                  }`}
    >
      {label}
    </button>
  );
};

export default NavItem;
